// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudServerOutlinedSvg from "@ant-design/icons-svg/es/asn/CloudServerOutlined";
import AntdIcon from '../components/AntdIcon';

var CloudServerOutlined = function CloudServerOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudServerOutlinedSvg
  }));
};

CloudServerOutlined.displayName = 'CloudServerOutlined';
export default React.forwardRef(CloudServerOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CloudServerOutlined.js
// module id = 803
// module chunks = 0